<template>
  <div id="data-joiner-home">
    <PluginHeader
      title="Data Joiner"
      subtitle="Stack datasets into one, or join them by coordinate"
      icon="fas fa-folder-tree"
    />
    <ChooseDatasets />
    <!-- Global spinner overlay while joinDatasets is loading every
         selected dataset's GeoJSON from Storage. -->
    <div v-if="spinner" class="dj-spinner-overlay">
      <RingLoader :color="'#066739'" :size="'50px'" />
    </div>
  </div>
</template>

<script>
import RingLoader from 'vue-spinner/src/RingLoader'
import ChooseDatasets from './ChooseDatasets'
import PluginHeader from '../_shared/PluginHeader.vue'
import dataJoinerModule from './store/module.js'

export default {
  components: { ChooseDatasets, RingLoader, PluginHeader },
  computed: {
    spinner () {
      return this.$store.state.dataJoiner && this.$store.state.dataJoiner.spinner
    }
  },
  beforeCreate () {
    // Register the namespaced module fresh on entry so each visit
    // starts from clean state (empty chosenDatasets, empty merges,
    // root folder, etc.).
    if (!this.$store.hasModule || !this.$store.hasModule('dataJoiner')) {
      this.$store.registerModule('dataJoiner', dataJoinerModule)
    }
  },
  beforeDestroy () {
    if (this.$store.hasModule && this.$store.hasModule('dataJoiner')) {
      this.$store.unregisterModule('dataJoiner')
    }
  },
}
</script>

<style scoped>
/* Cover the legacy plugin's body background (was black) so the
   page reads on the same neutral surface as the rest of myEV.
   Content starts under the shared 56px plugin header. */
#data-joiner-home {
  position: fixed;
  inset: 0;
  padding-top: 56px;
  background: #f7f9fa;
  overflow-y: auto;
}
.dj-spinner-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  z-index: 3;
}
</style>
